import { render, staticRenderFns } from "./SensorTypeLabel.vue?vue&type=template&id=2ce5a61a&scoped=true&"
import script from "./SensorTypeLabel.vue?vue&type=script&lang=js&"
export * from "./SensorTypeLabel.vue?vue&type=script&lang=js&"
import style0 from "./SensorTypeLabel.vue?vue&type=style&index=0&id=2ce5a61a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5a61a",
  null
  
)

/* custom blocks */
import block0 from "./SensorTypeLabel.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce5a61a')) {
      api.createRecord('2ce5a61a', component.options)
    } else {
      api.reload('2ce5a61a', component.options)
    }
    module.hot.accept("./SensorTypeLabel.vue?vue&type=template&id=2ce5a61a&scoped=true&", function () {
      api.rerender('2ce5a61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/SensorTypeLabel.vue"
export default component.exports